import React, { useState, useCallback } from "react";
import { Container, Box, Typography } from "@mui/material";
import SuggestListFilter from "../SuggestListFilter";
import SuggestListTable from "../SuggestListTable";
import PaginatedListLayout from "../../../shared/pagination/PaginatedListLayout";
import useSuggestionsIndex from "../../../shared/hooks/useSuggestionsIndex";
import {
  DEFAULT_PER_PAGE,
  createInitialPagination,
} from "../../../utils/pagination";

const SuggestListPage = () => {
  // 表示対象のページ種別（複数選択可）
  const [pageTypes, setPageTypes] = useState([]);

  // 並び順（優先度 or 作成日）
  const [sort, setSort] = useState("priority");

  // 現在のページ番号
  const [page, setPage] = useState(1);

  // ページング情報の初期値
  const initialPagination = createInitialPagination(DEFAULT_PER_PAGE);

  // サジェスト一覧取得
  const base = useSuggestionsIndex({
    mode: "company",
    pageTypes,
    page,
    per: DEFAULT_PER_PAGE,
    sort,
  });

  // ページ上部へスクロール
  const scrollToListTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  // ページ切り替え
  // Paginationコンポーネントから呼ばれる
  const goToPage = useCallback(
    (nextPage) => {
      scrollToListTop();
      setPage(nextPage);
    },
    [scrollToListTop],
  );

  // フィルタ変更時は1ページ目に戻す
  const handleChangePageTypes = useCallback((nextPageTypes) => {
    setPage(1);
    setPageTypes(nextPageTypes);
  }, []);

  // 並び順変更時は1ページ目に戻す
  const handleChangeSort = useCallback(
    (nextSort) => {
      scrollToListTop();
      setPage(1);
      setSort(nextSort);
    },
    [scrollToListTop],
  );

  return (
    <Container maxWidth="md" sx={{ position: "relative", mt: 2, mb: 10 }}>
      {/* ページタイトル */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          サジェスト一覧
        </Typography>
      </Box>

      {/* フィルター・並び順切り替え */}
      <Box
        sx={{
          position: "sticky",
          top: 55,
          zIndex: 10,
          backgroundColor: "#F4F7FA",
          py: 1,
        }}
      >
        <SuggestListFilter
          pageTypes={pageTypes}
          onChangePageTypes={handleChangePageTypes}
          sort={sort}
          onChangeSort={handleChangeSort}
        />
      </Box>

      {/* 一覧レイアウト（件数・ローディング・ページングなど） */}
      <PaginatedListLayout
        items={base.suggestions}
        loading={base.loading}
        pagination={base.pagination ?? initialPagination}
        onPageChange={goToPage}
        emptyText="データがありません。"
      >
        <SuggestListTable items={base.suggestions} onRefetch={base.refetch} />
      </PaginatedListLayout>
    </Container>
  );
};

export default SuggestListPage;
